import { ProvidersModalPurpose, useProvidersModal } from '@app/src/context/ProvidersModalContext'
import React from 'react'
import ConnectProvidersModal from '../Provider/ConnectProviders/ConnectProvidersModal'

interface ConnectOnlyProvidersModalProps {
  showInviteOption?: boolean
  additionalSteps?: React.ReactNode
}

const ConnectOnlyProvidersModal: React.FC<ConnectOnlyProvidersModalProps> = ({
  showInviteOption = false,
  additionalSteps,
}) => {
  const { isConnectDialogOpen, handleCloseConnectDialog, modalPurpose } = useProvidersModal()

  if (modalPurpose !== ProvidersModalPurpose.Connect) {
    return null
  }

  return (
    <ConnectProvidersModal
      onClose={handleCloseConnectDialog}
      open={isConnectDialogOpen}
      showInviteOption={showInviteOption}
      additionalSteps={additionalSteps}
    />
  )
}

export default ConnectOnlyProvidersModal
